module.exports = __webpack_public_path__ + "img/rm-white.cf6724eb.png";